export default __webpack_public_path__ + "static/media/caterium_ingot.94de07e8.png";